export const LOAD_ISSUES = 'LOAD_ISSUES';
export const CLEAR_ISSUES = 'CLEAR_ISSUES';
export const CHANGE_ISSUE_LIST_OPTIONS = 'CHANGE_ISSUE_LIST_OPTIONS';
export const LOAD_ISSUES_INNER_DATA = 'LOAD_ISSUES_INNER_DATA';
export const CLEAR_ISSUES_INNER_DATA = 'CLEAR_ISSUES_INNER_DATA';
export const ADD_ISSUE = 'ADD_ISSUE';
export const CHANGE_ISSUE_STATUS = 'CHANGE_ISSUE_STATUS';
export const LOAD_ISSUE_DETAILS = 'LOAD_ISSUE_DETAILS';
export const CLEAR_ISSUE_DETAILS = 'CLEAR_ISSUE_DETAILS';
export const DELETE_ISSUE = 'DELETE_ISSUE';
export const EDIT_ISSUE = 'EDIT_ISSUE';
